<label
  class="form-radio-label form__control"
  [class.disabled]="isDisabled()"
  [class.with-value]="inputFormControl().getRawValue() === inputValue()"
>
  <input
    class="form-radio-input"
    [value]="inputValue()"
    [name]="inputName()"
    [attr.disabled]="isDisabled() ? true : null"
    [formControl]="inputFormControl()"
    type="radio"
  >

  <ng-content/>
</label>
